angular.module('core')
  .service('classroomStandardsApi', [
    '$state',
    'standardsApi',
    'exportService',
    'cancelableResourceManager',
    'configuration', function (
    $state,
    $standardsApi,
    $exportService,
    $cancelableResourceManager,
    dblConfigurationService)
  {
    var self = this;

    /**
     * Returns object with keys that are names of standards that have new lessons within the AST.
     *
     **/
    var getStandardsWithNewLessons = function (ast) {
        var astToStandardsWithNewLessonsMap = dblConfigurationService.getAstToStandardsWithNewLessonsMap(ast);

        return astToStandardsWithNewLessonsMap[ast] || {};
    };

    self.getClassroomStandardsGrid = function (classroom_id, grade_id, ast) {
      var params = _.pick($state.params, ['districtId']);
      params.classroomId = classroom_id;
      params.level_id = grade_id;
      params.untilNow = true;

      var standardsWithNewLessons = getStandardsWithNewLessons(ast);

      var promises = $standardsApi.ClassroomStandards.all(params);
      $cancelableResourceManager.addAndRemoveOnFinish(promises);
      return promises.$promise.then(function (standardsData) {
        var data = {
          domains: [],
          clusters: [],
          standards: [],
          students: []
        };
        _.each(standardsData.levels, function (level) {
          // var edexLevel = {name: level.name};
          _.each(level.domains, function (domain) {
            var edexDomain = {name: domain.name, code: domain.code, description: domain.description, clusters: [], standards: []};
            data.domains.push(edexDomain);
            _.each(domain.clusters, function (cluster) {
              var edexCluster = {name: cluster.name, standards: []};
              edexDomain.clusters.push(edexCluster);
              data.clusters.push(edexCluster);
              _.each(cluster.standards, function (standard) {
                var edexStandard = {
                  domain: edexDomain,
                  name: standard.name,
                  code: standard.code,
                  totals: standard.totals,
                  description: standard.description,
                  short_description: standard.short_description,
                  percent_complete: standard.percent_complete
                };

                edexStandard.has_new_lessons = !!standardsWithNewLessons[standard.name];

                edexCluster.standards.push(edexStandard);
                edexDomain.standards.push(edexStandard);
                data.standards.push(edexStandard);
              });
            });
          });
        });

        _.each(standardsData.students, function (student) {
          var edexStudent = {
            id: student.id,
            name: student.first_name + " " + student.last_name,
            firstName: student.first_name,
            lastName: student.last_name,
            standards: [],
            type: 'student'
          };
          data.students.push(edexStudent);
          _.each(student.levels, function (level) {
            _.each(level.domains, function (domain) {
              _.each(domain.clusters, function (cluster) {
                _.each(cluster.standards, function (standard) {
                  standard.domain = domain;
                  edexStudent.standards.push(standard);
                });
              });
            });
          });
        });
        return data;
      });
    };
  }]
);
